'use strict';

/**
 *
 * @name: QqRedirectController
 *
 */

function QqRedirectController(
  $location,
  $rootScope,
  apiUserService) {

  'ngInject';

  /*
   *
   * @CONFIG
   *
   */

  /*
   *
   * @PUBLIC
   *
   */

  /*
   *
   * @PRIVATE
   *
   */

  function _getAccessToken() {

    var params = $location.hash().split('&');
    var accessToken = params[0].split('=')[1];

    return accessToken;
  }

  function _login() {

    var accessToken = _getAccessToken();

    var userData = {
      source: 'qq',
      socialToken: accessToken,
      roles: ['member'],
      language: $rootScope.lang,
      receiveDailyNewsletter: true,
      receiveWeeklyNewsletter: true,
      receiveOffers: false,
      isPublic: true
    };

    apiUserService
      .register(userData, true)
      .then(function() {

        apiUserService.getUser(true)
          .then(function() {
            
            $location.search({});
            $location.path('/profile/account-feed');
          });
      });
  }

  /*
   *
   * @INIT
   *
   */

  _login();

}

export default QqRedirectController;



// WEBPACK FOOTER //
// ./app/pages/social-redirects/qq-redirect.controller.js